/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

export class WrcDate { //extends Date {
    /**
     * system wide date format
     * @type {string}
     */
    static DATE_DISPLAYSEPARATOR = '/';
    static DATE_DBSEPARATOR = '-';
    static DATE_DISPLAYFMT = "mm/dd/yyyy";  // old: yyyy-mm-dd
    static DATE_DBFMT = "yyyy-mm-dd";
    static DATE_DBDEFAULTTIME = '00:00:00'; // for now, set everything to midnight

    static tzOffset = -(new Date().getTimezoneOffset());

    /**
     * pad out 100s
     * @param num
     * @returns {string}
     */
    static pad00(num) {
        const norm = Math.floor(Math.abs(num));
        return ((norm < 10 ? '0' : '') + norm);
    }

    /**
     * get the timezone offset as a string
     * @returns {string}
     */
    static getTzOffsetStr(){
        const tzo = this.tzOffset,
            dif = tzo >= 0 ? '+' : '-';

        return(
            dif + this.pad00(tzo / 60) +
            ':' + this.pad00(tzo % 60)
        );
    }

    static getTzISO = () => ('T' + WrcDate.DATE_DBDEFAULTTIME + WrcDate.getTzOffsetStr());

    /**
     * return ISO date for the given date
     * @type {number}
     */
    static toIsoDate(thedate){
        const newdate = thedate.getFullYear() +
            '-' + this.pad00(thedate.getMonth() + 1) +
            '-' + this.pad00(thedate.getDate()) +
            'T' + this.pad00(thedate.getHours()) +
            ':' + this.pad00(thedate.getMinutes()) +
            ':' + this.pad00(thedate.getSeconds()) +
            this.getTzOffsetStr();

        return newdate;
    }

    /**
     * internal JavaScript Date object
     * @type {string}
     */
    JsDate = 'no date';//

    constructor(tmpdate) {
        if(!tmpdate){
            let thedate = new Date();

            thedate.setHours(0);
            thedate.setMinutes(0);
            thedate.setSeconds(0);

            this.JsDate = thedate;
            return;

        } else if (tmpdate.split && tmpdate.split(WrcDate.DATE_DBSEPARATOR).length === 3) {
            // if given a string - get the date for the current timezone
            tmpdate = WrcDate.toIsoDate(new Date(tmpdate + WrcDate.getTzISO()));
        } else if (tmpdate.split && tmpdate.split(WrcDate.DATE_DBSEPARATOR).length === 3) {
            // this is fine...
        }

        let thedate = new Date(tmpdate);

        thedate.setHours(0);
        thedate.setMinutes(0);
        thedate.setSeconds(0);

        this.JsDate = thedate;
    }

    getJsDate() {
        return this.JsDate;
    }

    /**
     * return the given JS date as a DB-formatted (ISO) string
     * @param date - a javascript date
     * @returns {string}
     */
    getDatabaseDate(){
        const thedate = this.getJsDate();

        thedate.setHours(0);
        thedate.setMinutes(0);
        thedate.setSeconds(0);

        if(thedate && thedate.toISOString){
            let dstr = thedate.toISOString(),
                darr = dstr.split('T'); //split at the start of the time component

            if (darr.length) {
                return darr[0];
//                let dret = darr[0] + WrcDate.getTzISO();
//                return dret
            }
        }
        // console.warn('getDatabaseDate return date: ', thedate, ' as ""');
        return '';
    }

    /**
     * return the given date as a display-formatted string
     * @param date - a javascript date
     * @returns {string}
     */
    getDisplayDate(){
        const thedate = this.getJsDate();
        return thedate.toLocaleDateString();
    }
}